<template>
	<section class="container">
		<div class="column mt-4 mb-4">
			<vue-friendly-iframe :src="srcOfMap" title="Mapa de Terrassa on es visualitzen les cases tapiades" />
		</div>

		<div class="content column mt-4 mb-6">
			<article class="message is-success">
				<div class="message-body">
					Cada marca al mapa és un edifici tapiat amb la seva corresponent fotografia.<br>
					Les marques de color taronja són d’edificis fotografiats entre 2020 i 2021.<br>
					Les marques de color verd són d’edificis ja registrats a la plataforma <b-tooltip multilined label="Cases buides va ser una plataforma amb l'objectiu de realitzar un cens d'habitatges buits a Terrassa"><a target="_blank" rel="noreferrer noopener" href="https://15mpedia.org/wiki/Cases_Buides_Terrassa">Cases Buides</a></b-tooltip>, prèvia al 2016 i fotografiades entre 2020 i 2021.<br>
				</div>
			</article>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			srcOfMap: 'https://www.google.com/maps/d/embed?mid=1mVvnl8dJBDUhIThN44inQ3TvHe-pf-0W'
		}
	}
}
</script>

<style>
.vue-friendly-iframe {
	height: 500px;
}

.vue-friendly-iframe iframe {
	width : 100%;
	height: 100%;
}

@media only screen and (min-width: 768px) {
	.vue-friendly-iframe {
		height: 640px;
	}
}

@media only screen and (min-width: 1024px) {
	.vue-friendly-iframe {
		height: 800px;
	}
}
</style>
